// Features.js

function Features() {
  return (
    <section className="features">
      <h2>⭐ WHY CHOOSE DEMO PLAY? ⭐</h2>
      <div className="features-grid">
        <div className="feature-card">
          <div className="feature-icon">💰</div>
          <h3>100% FREE</h3>
          <p>Play all games without spending a single cent. No deposits, no hidden costs, pure entertainment!</p>
        </div>
        <div className="feature-card">
          <div className="feature-icon">🛡️</div>
          <h3>RISK-FREE FUN</h3>
          <p>Enjoy the excitement without financial stress. Learn strategies and have fun safely!</p>
        </div>
        <div className="feature-card">
            <div className="feature-icon">🎯</div>
            <h3>PRACTICE MODE</h3>
            <p>Master game mechanics and develop skills before considering real social casino games experiences.</p>
        </div>
        <div className="feature-card">
            <div className="feature-icon">🎮</div>
            <h3>UNLIMITED PLAY</h3>
            <p>No time limits, no restrictions. Play as much as you want, whenever you want!</p>
        </div>
        <div className="feature-card">
            <div className="feature-icon">🌟</div>
            <h3>VARIETY</h3>
            <p>Access dozens of different slot themes and game types. Something new every day!</p>
        </div>
        <div className="feature-card">
            <div className="feature-icon">📱</div>
            <h3>MOBILE READY</h3>
            <p>Play on any device - desktop, tablet, or smartphone. Entertainment on the go!</p>
        </div>
      </div>
    </section>
  );
}

export default Features;